import Box from '@mui/material/Box';
import { UserRoleAtom } from 'atoms';
import Notification from 'common/Notification';
import PageStructure from 'common/PageStructure';
import { useInvoiceDetails } from 'hooks/useInvoiceDetails';
import { Invoice } from 'pages/Payment/Invoice';
import PageHeader from 'pages/Payment/Partials/PageHeader';

import React, { useState } from 'react';
import { useRecoilState } from 'recoil';

const Payment = () => {
    const [userRole] = useRecoilState(UserRoleAtom)
    const [notification, setNotification] = useState('');
    const [providerEmail] = useInvoiceDetails();
    const [hasStripeAccount, setHasStripeAccount] = useState(null); // null = unknown, false = no account, true = has account
    const [isInitialLoad, setIsInitialLoad] = useState(true);
    
    const clearNotification = () => {
        setNotification('');
    };
    
    const handleAccountStatusChange = (hasAccount) => {
        setHasStripeAccount(hasAccount);
        setIsInitialLoad(false);
    };
    
    return (
        <div>
            <PageStructure heading="Payments">
                <Box
                    className="payment"
                    component="main"
                    sx={{ 
                        flexGrow: 1, 
                        bgcolor: '#f5f1ed', 
                        px: 7.5, 
                        py: 5, 
                        height: '100%', 
                        minHeight: '100%', 
                        display: 'flex', 
                        flexDirection: 'column',
                        '@media (max-width: 960px)': {
                            paddingLeft: '32px',
                            paddingRight: '32px',
                        },
                        '@media (max-width: 640px)': {
                            paddingLeft: '20px',
                            paddingRight: '20px',
                        },
                    }}
                >
                    {userRole !== 'General' && (
                        <PageHeader onAccountStatusChange={handleAccountStatusChange}></PageHeader>
                    )}
                    {(!isInitialLoad && hasStripeAccount === true) && <Invoice></Invoice>}
                </Box>
            </PageStructure>

            {notification && <Notification message="Invoice Sent!" name={providerEmail} onClose={clearNotification} />}
        </div>
    );
};

export default Payment;
